import {useUser} from "../../../../../misc/Permission";
import {useReadyCheck} from "../../../../../misc/pdf/UseReadyCheck";
import {ContainerPage} from "../../../../../misc/pdf/parts/ContainerPage";
import {TitleTextBlock} from "../../../../../misc/pdf/parts/TitleTextBlock";
import {grey} from "@mui/material/colors";

export function DoorElevationAndLiteKitProfilesPages(props: {
    title: string;
    doorElevations: {
        name: string;
        image: string;
        profile: string | null;
    }[];
    onReady(): void;
}) {
    const usr = useUser();
    const ready = useReadyCheck(props.onReady);
    ready.require(!!usr);

    // make groups of 3
    const pages : {name: string; image: string; profile: string | null}[][] = [];

    props.doorElevations.map((e, i) => {
        if(i % 3 === 0) {
            pages.push([]);
        }

        pages[pages.length - 1].push(e);
    })

    return (
        <>
            {pages.map((p, i) => {
                return (
                    <ContainerPage key={i.toString()}>
                        <TitleTextBlock title={props.title}>
                            <div style={{
                                flex: 1,
                                display: "flex", flexDirection: "row",
                                justifyContent: "flex-start"
                            }}>

                                {p.map((e, index) => {
                                    return (
                                        <div style={{
                                            border: "1px solid " + grey["200"],
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                            width: "33.333%",
                                            height: "100%",
                                            paddingLeft: 4,
                                            paddingRight: 4,
                                        }}>
                                            <div key={index.toString()} style={{
                                                flex: 2,
                                                backgroundImage: e.image ? "url(" + e.image + ")" : "none",
                                                backgroundSize: "contain",
                                                backgroundPosition: "center center",
                                                backgroundRepeat: "no-repeat",
                                            }}></div>

                                            <div key={index.toString()} style={{
                                                flex: 1,
                                                backgroundImage: e.profile ? "url(" + e.profile + ")" : "none",
                                                backgroundSize: "contain",
                                                backgroundPosition: "center center",
                                                backgroundRepeat: "no-repeat",
                                            }}></div>
                                        </div>
                                    )
                                })}

                            </div>
                        </TitleTextBlock>
                    </ContainerPage>
                )
            })}
        </>
    )
}